import React, { useState } from "react";
import {
  Typography,
  IconButton,
  Box,
  Stack,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import {
  MessageType,
  priorityValueColor,
  priorityValueLable
} from "../../utils/constant";
import { fontSizeSchemes } from "../../assets/commonFunction";
import moment from "moment";
import PersonIcon from "../../assets/images/chats/person.svg";
import { createStyledIndicatorButton } from "../StyledComponents/SideBarComponents";
import TaskStatusButton from "../../components/TaskStatusButton/TaskStatusButton";

const useStyles = () => ({
  chatpri: {
    // lineHeight: "14px",
    fontSize: fontSizeSchemes.font12,
    fontWeight: 400,
    whiteSpace: "nowrap",
    marginLeft: "-5px",
  },
});

function TaskCardList({
  task,
  level = 0,
  onDragStart,
  onDragOver,
  onDrop,
  onDragEnd,
  isDragOver,
  isDragging,
  taskItem,
  isLastChild = false,
}) {
  const classes = useStyles();
  const SmallActionButton = createStyledIndicatorButton("#e6e3e3ff");

  return (
    <Box
      sx={{
        // position: "relative",
        pl: level > 0 ? "40px" : 0,
        // "&::before": level > 0 && {
        //   content: '""',
        //   position: "absolute",
        //   left: "63px",
        //   top: "-23px",
        //   bottom: "23px",
        //   width: "2px",
        //   backgroundColor: "#e0e0e0",
        }
      }
    >
      <Box
        my={2}
        // mx={3}
        sx={{
          backgroundColor: isDragOver ? "rgba(25,118,210,0.05)" : "transparent",
          borderTop: isDragOver ? "3px solid #1976d2" : "none",
          borderRadius: isDragOver ? "8px" : "0",
          transition: "all 0.2s ease",
          opacity: isDragging ? 0.6 : 1,
        }}
        onDragOver={(e) => {
          e.preventDefault();
          onDragOver && onDragOver(e, task);
        }}
        onDrop={(e) => onDrop && onDrop(e, task)}
        onDragEnd={onDragEnd}
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          <Box
            draggable
            onDragStart={(e) => onDragStart && onDragStart(e, task)}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "text.secondary",
              cursor: isDragging ? "grabbing" : "grab",
              "&:hover": { color: "primary.main" },
            }}
          >
            <DragIndicatorIcon
              fontSize="large"
              sx={{ color: "rgba(79, 79, 79, 0.25)", marginRight: "-10px" }}
            />
          </Box>

          <SmallActionButton size="small" variant="contained">
            <img
              style={{ width: "100%", height: "100%" }}
              src={PersonIcon}
              alt="group"
            />
          </SmallActionButton>

          <Box flex={1} ml="-7px">
            <Typography
              variant="body2"
              fontWeight="medium"
              color="text.primary"
            >
              {taskItem?.assignee?.name || task.name}:{" "}
              <Typography component="span" fontSize="14px" sx={{ ml: 0.5 }}>
                {task.title || "Prepare message thread functionality"}
              </Typography>
            </Typography>

            <Stack direction="row" alignItems="center" spacing={1}>
              <Box display="flex" alignItems="center" gap={1}>
                {/* Due Date */}
                <Typography
                  variant="subtitle2"
                  fontSize={fontSizeSchemes.font12}
                  fontWeight={600}
                >
                  Due:&nbsp;
                  {taskItem?.due_date
                    ? moment(taskItem.due_date).format("DD-MM-YYYY")
                    : task.due || "--"}
                </Typography>

                <Typography
                  fontSize={fontSizeSchemes.font12}
                  fontWeight={600}
                  ml="-4px"
                >
                  |
                </Typography>

                {/* Priority */}
                <Typography sx={classes.chatpri}>
                  Priority:
                  <span
                    style={{
                      display: "inline-block",
                      width: "13px",
                      height: "13px",
                      verticalAlign: "middle",
                      margin: "-1px 5px 0px 5px",
                      backgroundColor:
                        priorityValueColor[taskItem?.priority] ||
                        priorityValueColor[task.priority],
                    }}
                  ></span>
                  {priorityValueLable[taskItem?.priority] ||
                    priorityValueLable[task.priority]}
                </Typography>
              </Box>

             <TaskStatusButton
                                     item={taskItem}
                                     status={"task"}
                                     isCondition={taskItem?.type === MessageType?.Task}
                                   />
            </Stack>
          </Box>

          <IconButton size="small">
            <MoreVertIcon fontSize="small" />
          </IconButton>
        </Stack>

        {/* Render children recursively */}
        {task.children?.map((child, index) => (
          <TaskCardList
            key={child.id}
            task={child}
            level={level + 1}
            onDragStart={onDragStart}
            onDragOver={onDragOver}
            onDrop={onDrop}
            onDragEnd={onDragEnd}
            isLastChild={index === task.children.length - 1}
          />
        ))}
      </Box>
    </Box>
  );
}


export default function TaskList({ taskItem }) {
  const [tasks, setTasks] = useState([
    {
      id: 1,
      name: "Dianne Russell",
      title: "Prepare message thread functionality",
      due: "11-07-2025",
      priority: "Medium",
      status: "Pending",
    },
    {
      id: 2,
      name: "Courtney Henry",
      title: "Create drag & drop for task list",
      due: "15-07-2025",
      priority: "High",
      status: "In Progress",
    },
    {
      id: 3,
      name: "Robert Fox",
      title: "Review API integration",
      due: "20-07-2025",
      priority: "Low",
      status: "Pending",
    },
  ]);

  const [draggingId, setDraggingId] = useState(null);
  const [dragOverId, setDragOverId] = useState(null);

  const handleDragStart = (e, task) => {
    setDraggingId(task.id);
    e.dataTransfer.effectAllowed = "move";
  };

  const handleDragOver = (e, task) => {
    e.preventDefault();
    setDragOverId(task.id);
  };

  const handleDrop = (e, targetTask) => {
    e.preventDefault();
    const draggedIndex = tasks.findIndex((t) => t.id === draggingId);
    const targetIndex = tasks.findIndex((t) => t.id === targetTask.id);
    if (draggedIndex === targetIndex) return;

    const updated = [...tasks];
    const [moved] = updated.splice(draggedIndex, 1);
    updated.splice(targetIndex, 0, moved);
    setTasks(updated);
    setDraggingId(null);
    setDragOverId(null);
  };

  const handleDragEnd = () => {
    setDraggingId(null);
    setDragOverId(null);
  };

  return (
    <div className="p-4 bg-white rounded-lg shadow-sm border">
      {tasks.map((task, index) => (
        <TaskCardList
          key={task.id}
          task={task}
          level={index === 0 ? 0 : 1}
          onDragStart={handleDragStart}
          onDragOver={handleDragOver}
          onDrop={handleDrop}
          onDragEnd={handleDragEnd}
          isDragging={draggingId === task.id}
          isDragOver={dragOverId === task.id}
          taskItem={taskItem}
        />
      ))}
    </div>
  );
}
